import React from 'react';
import PropTypes from 'prop-types';

const Services = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox={'0 0 280 197'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <rect
        x={'273.437'}
        y={'6.56299'}
        width={'183.75'}
        height={'266.875'}
        transform={'rotate(90 273.437 6.56299)'}
        stroke={'white'}
        strokeWidth={'4.375'}
        strokeDasharray={'8.75 8.75'}
      />
      <rect
        x={'278.904'}
        width={'8.75'}
        height={'8.75'}
        transform={'rotate(90 278.904 0)'}
        fill={'white'}
      />
      <rect
        x={'8.75391'}
        y={'0.000488281'}
        width={'8.75'}
        height={'8.75'}
        transform={'rotate(90 8.75391 0.000488281)'}
        fill={'white'}
      />
      <rect
        x={'280'}
        y={'188.125'}
        width={'8.75'}
        height={'8.75'}
        transform={'rotate(90 280 188.125)'}
        fill={'white'}
      />
      <rect
        x={'12.0293'}
        y={'185.938'}
        width={'8.75'}
        height={'8.75'}
        transform={'rotate(90 12.0293 185.938)'}
        fill={'white'}
      />
      <path
        fillRule={'evenodd'}
        clipRule={'evenodd'}
        d={
          'M159.121 107.752C159.121 125.572 173.567 140.018 191.387 140.018C209.207 140.018 223.652 125.572 223.652 107.752C223.652 89.9323 209.207 75.4864 191.387 75.4864C173.567 75.4864 159.121 89.9323 159.121 107.752ZM96.2389 108.391L117.242 85.0642L86.5392 91.5903L70.8447 64.4067L67.5637 95.6237L36.8607 102.15L65.5359 114.917L62.2549 146.134L83.2582 122.807L111.933 135.574L96.2389 108.391Z'
        }
        fill={'black'}
      />
      <path
        d={
          'M117.242 85.0642L118.868 86.5279L123.373 81.5248L116.787 82.9245L117.242 85.0642ZM96.2389 108.391L94.6133 106.927L93.5498 108.108L94.3445 109.484L96.2389 108.391ZM86.5392 91.5903L84.6448 92.6841L85.4394 94.0605L86.994 93.73L86.5392 91.5903ZM70.8447 64.4067L72.7392 63.313L69.373 57.4825L68.6692 64.1781L70.8447 64.4067ZM67.5637 95.6237L68.0185 97.7634L69.5731 97.4329L69.7392 95.8523L67.5637 95.6237ZM36.8607 102.15L36.4059 100.01L29.8206 101.41L35.971 104.148L36.8607 102.15ZM65.5359 114.917L67.7114 115.145L67.8776 113.565L66.4257 112.918L65.5359 114.917ZM62.2549 146.134L60.0794 145.905L59.3757 152.601L63.8805 147.597L62.2549 146.134ZM83.2582 122.807L84.1479 120.809L82.696 120.162L81.6325 121.344L83.2582 122.807ZM111.933 135.574L111.044 137.573L117.194 140.311L113.828 134.481L111.933 135.574ZM191.387 137.83C174.775 137.83 161.309 124.364 161.309 107.752L156.934 107.752C156.934 126.78 172.359 142.205 191.387 142.205L191.387 137.83ZM221.465 107.752C221.465 124.364 207.998 137.83 191.387 137.83L191.387 142.205C210.415 142.205 225.84 126.78 225.84 107.752L221.465 107.752ZM191.387 77.6739C207.998 77.6739 221.465 91.1404 221.465 107.752L225.84 107.752C225.84 88.7241 210.415 73.2989 191.387 73.2989L191.387 77.6739ZM161.309 107.752C161.309 91.1404 174.775 77.6739 191.387 77.6739L191.387 73.2989C172.359 73.2989 156.934 88.7241 156.934 107.752L161.309 107.752ZM115.617 83.6005L94.6133 106.927L97.8645 109.854L118.868 86.5279L115.617 83.6005ZM86.994 93.73L117.697 87.2039L116.787 82.9245L86.0844 89.4506L86.994 93.73ZM68.9503 65.5005L84.6448 92.6841L88.4336 90.4966L72.7392 63.313L68.9503 65.5005ZM69.7392 95.8523L73.0203 64.6354L68.6692 64.1781L65.3882 95.395L69.7392 95.8523ZM37.3155 104.29L68.0185 97.7634L67.1089 93.484L36.4059 100.01L37.3155 104.29ZM66.4257 112.918L37.7505 100.151L35.971 104.148L64.6462 116.915L66.4257 112.918ZM64.4304 146.362L67.7114 115.145L63.3604 114.688L60.0794 145.905L64.4304 146.362ZM81.6325 121.344L60.6293 144.67L63.8805 147.597L84.8838 124.271L81.6325 121.344ZM112.823 133.576L84.1479 120.809L82.3684 124.806L111.044 137.573L112.823 133.576ZM94.3445 109.484L110.039 136.668L113.828 134.481L98.1333 107.297L94.3445 109.484Z'
        }
        fill={'black'}
      />
      <path
        d={
          'M123.275 78.9775L102.272 102.304L117.967 129.488L89.2914 116.721L68.2881 140.047L71.5691 108.83L42.8939 96.0631L73.5969 89.537L76.878 58.32L92.5724 85.5036L123.275 78.9775Z'
        }
        fill={'white'}
        stroke={'black'}
        strokeWidth={'4.375'}
      />
      <circle
        cx={'197.422'}
        cy={'101.668'}
        r={'32.2656'}
        transform={'rotate(90 197.422 101.668)'}
        fill={'white'}
        stroke={'black'}
        strokeWidth={'4.375'}
      />
      <circle
        cx={'209.578'}
        cy={'68.3687'}
        r={'11.0915'}
        fill={'black'}
        stroke={'black'}
        strokeWidth={'2.21831'}
      />
      <path
        d={
          'M212.353 70.2297L212.353 71.6969L207.418 71.6969L207.418 70.6489L210.027 68.1337C210.141 68.0219 210.243 67.9066 210.333 67.7878C210.417 67.69 210.488 67.5782 210.549 67.4524C210.617 67.3267 210.651 67.2044 210.651 67.0856C210.651 66.876 210.583 66.7118 210.447 66.5931C210.311 66.4673 210.114 66.4044 209.857 66.4044C209.57 66.4044 209.346 66.4778 209.188 66.6245C209.029 66.7712 208.949 66.9773 208.949 67.2428L207.361 67.138C207.361 66.8376 207.418 66.5616 207.531 66.3101C207.652 66.0516 207.819 65.828 208.031 65.6394C208.25 65.4507 208.511 65.304 208.813 65.1992C209.123 65.0944 209.471 65.042 209.857 65.042C210.25 65.042 210.602 65.0909 210.912 65.1887C211.222 65.2865 211.483 65.4263 211.695 65.6079C211.914 65.7826 212.076 65.9922 212.182 66.2367C212.296 66.4813 212.353 66.7468 212.353 67.0332C212.353 67.2848 212.292 67.5258 212.171 67.7564C212.058 67.9799 211.929 68.1791 211.785 68.3537C211.619 68.5564 211.43 68.745 211.218 68.9197L209.857 70.2297L212.353 70.2297Z'
        }
        fill={'white'}
      />
      <circle cx={'91.8745'} cy={'68.4077'} r={'12.2007'} fill={'black'} />
      <path
        d={
          'M93.5384 64.5244L93.5384 71.7339L91.8153 71.7339L91.8153 66.5843L91.0428 67.0992L90.2109 65.8404L92.1718 64.5244L93.5384 64.5244Z'
        }
        fill={'white'}
      />
    </svg>
  );
};

export default Services;

Services.defaultProps = {
  className: '',
};

Services.propTypes = {
  className: PropTypes.string,
};
